import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import "./assets/css/bootstrap.min.css";
import "./assets/css/font-icon.min.css";
import "./assets/css/datepicker.min.css";
import "./assets/css/commonCss.css";
import "./App.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./states/store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
